// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"Form_searchInput__12COA","formWrapper":"Form_formWrapper__3xyt7","errorTest":"Form_errorTest__UzLsD"};